import classnames from 'classnames';
import Icon from './icon';
import PropTypes from 'prop-types';
import React from 'react';

class Notification extends React.Component {
    render() {
        const {
            description,
            handleToggle,
            id,
            isVisible,
            title,
            type,
            url
        } = this.props;

        const notificationClass = classnames('notification', type, {
            'is-visible': isVisible,
        });

        return (
            <div className={notificationClass}>
                <div className="notification-inner || constrain-width large">
                    <Icon
                        className="notification-icon"
                        name={type}
                    />
                    <div className="notification-content">
                        <p className="notification-content-title">{title}</p>
                        {description && (url ? (
                            <p><a href={url}>{description}</a></p>
                        ) : (
                            <p>{description}</p>
                        ))}
                    </div>
                    <button className="icon-button || notification-close" onClick={() => handleToggle(id)}>
                        <Icon name="cross" />
                    </button>
                </div>
            </div>
        );
    }
}

Notification.propTypes = {
    description: PropTypes.string.isRequired,
    handleToggle: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    isVisible: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default Notification;
